<template>
  <div> 
    <div class="container-botoes mt-5 mb-5 text-right">
      <SGPFormBotaoComponent 
        class="mr-2"
        color="primary"
        @click="gerarRelatorio"
      >
      <SGPIconComponent
                      icon="mdi-file-document-outline"
                      color="second"
                    />
        Exportar Dados
      </SGPFormBotaoComponent>
    </div>  
    <SGPPaginacaoComponent
      :paginacao="paginacao"
      v-if="listaTarefas.data && listaTarefas.data.length"
      @sgpAtualizarPaginacao="realizarPaginacao"
      :key="paginacao"
    >
      <SGPTabelaComponent
        :colunas="colunas"
        :dados="listaPaginada"
        aceitaHtml
        @sgpAtualizarDadosTabelaEmit="listarTarefas(filtrosTarefas)"
        :usuarioPodeExcluir="false"
        :usuarioPodeEditar="false"
        itemKey="pco_tarefa_id"
        selecionarColunas
        somenteLeitura
        height="100vh"
        :textoParaFiltragem="filtroTexto"
        dense
        fixed-header
        :filtroText="true"
      >
        <template v-slot:item.aging_ps_tarefa="{ item }">
          {{ item.aging_ps_tarefa ? item.aging_ps_tarefa : item.aging_dias }} 
        </template>
      </SGPTabelaComponent>
    </SGPPaginacaoComponent>
    <SGPAlertaComponent v-else class="margin-top-10">
      Nenhum resultado foi encontrado!
    </SGPAlertaComponent>
    <SGPLoadingComponent v-if="loadingBacklog" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
export default {
  name: "DetalheTarefasComponent",
  props: {
    filtrosTarefas: {
      type: Object,
      required: true
    }
  },

  data () {
    return {
      filtroTexto: ''
    }
  },

  created () {
    this.listarTarefas(this.filtrosTarefas);
  },

  methods: {
    ...mapActions('backlog',[
      'listarTarefas',
      'detalheTarefasDownload'
    ]),

    gerarRelatorio () {
      this.detalheTarefasDownload(this.filtrosTarefas);
    },

    processaFiltroPorTexto (val) {
      this.filtroTexto = val
    },

    realizarPaginacao (paginacao) {
      this.listarTarefas({
        ...this.filtrosTarefas,
        ...paginacao});
    },
  },

  computed: {
    ...mapGetters('backlog', 
    [
      'listaTarefas',
      'loadingBacklog'
    ]),

    listaPaginada() {            
      if (!this.listaTarefas.data) return []            
        return this.listaTarefas.data
    },

    paginacao () {
      if (!this.listaTarefas.data) return {}
      
      const paginate =  {
        per_page: this.listaTarefas.per_page,
        total: this.listaTarefas.total,
        current_page: this.listaTarefas.current_page
      }

      return {
        per_page: paginate.per_page,
        total: paginate.total,
        current_page: paginate.current_page
      }
    },

    colunas () {
      return [
        {
          key: 'redirecionar',
          label: 'Ficha técnica',
          sortable: false,
          width: 50
        },
        {
          key: 'cod_cir_ponta',
          label: 'Circuito',
          sortable: true
        },
        {
          key: 'cm',
          label: 'CM',
          sortable: true
        },
        {
          key: 'cliente',
          label: 'Cliente',
          sortable: true
        },
        {
          key: 'servico',
          label: 'Serviço',
          sortable: true
        },
        {
          key: 'tipo_alteracao',
          label: 'Tipo Alteração',
          sortable: true
        },
        {
          key: 'classificacao_gross',
          label: 'Gross',
          sortable: true
        },
        {
          key: 'designacao',
          label: 'Designação',
          sortable: true
        },
        {
          key: 'status_tarefa',
          label: 'Status',
          sortable: true
        },
        {
          key: 'aging_ps_tarefa',
          label: 'Aging Tarefa'
        }
      ]
    },
  },

}
</script>